import React, { InputHTMLAttributes, PropsWithChildren } from 'react';

// Groups for checkboxes and radioboxes

interface GroupProps {
  horizontal?: boolean;
}

export const RadioGroup: React.FC<GroupProps & PropsWithChildren> = ({
  children,
  horizontal
}) => (
  <div className={'radio-group' + (horizontal ? ' radio-group-horizontal' : '')}>
    {children}
  </div>
);

export const CheckboxGroup: React.FC<GroupProps & PropsWithChildren> = ({
  children,
  horizontal
}) => (
  <div className={'radio-group' + (horizontal ? ' radio-group-horizontal' : '')}>
    {children}
  </div>
);

// Radioboxes

interface RadioProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
}

export const RadioButton: React.FC<RadioProps> = ({ label, ...props }) => {
  return (
    <label className="radio-input" title={props.title}>
      <input {...props} type="radio" />
      <span className="radio-input-label">{label}</span>
    </label>
  );
};

// Checkboxes

interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
}

export const Checkbox: React.FC<CheckboxProps> = ({ label, title, ...props }) => {
  return (
    <label title={title} className="radio-input">
      <input {...props} type="checkbox" />
      <span className="radio-input-label">{label}</span>
    </label>
  );
};
